export default "__VITE_ASSET__CCrnLqMp__"